<template>
  <div>
    <alert
      :visible="!!messageAlert"
      dark
      :type="typeAlert"
      :message="messageAlert"
      :clickClose="() => (messageAlert = '')"
    />
    <v-data-table
      :headers="headers"
      :loading="loading"
      :items="providers"
      :search="search"
      sort-by="name"
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title
            >CONDIÇÃO DE PAGAMENTO POR FORNECEDOR</v-toolbar-title
          >
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Busca"
            single-line
            hide-details
          ></v-text-field>
          <v-spacer></v-spacer>
          <!-- <v-btn color="blue darken-1" dark to="/ncm/novo">
            <v-icon>mdi-plus</v-icon>
            Novo
          </v-btn> -->
        </v-toolbar>
      </template>
      <!-- eslint-disable-next-line -->
      <template v-slot:item.name="{ item }">
        {{ item.code }} - {{ item.name }}
      </template>
      <!-- eslint-disable-next-line -->
      <template v-slot:item.payments="{ item }">
        <ul>
          <li
            v-for="payment in getPaymentsProviderTable(item)"
            :key="payment.id"
          >
            {{ payment.name }}
          </li>
        </ul>
      </template>
      <!-- eslint-disable-next-line -->
      <template v-slot:item.actions="{ item }">
        <v-tooltip top color="blue darken-1">
          <!-- eslint-disable-next-line -->
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              class="mr-2"
              color="blue darken-1"
              @click="editItem(item)"
              v-bind="attrs"
              v-on="on"
            >
              mdi-application-cog
            </v-icon>
          </template>
          <span>Vincular Condição</span>
        </v-tooltip>
        <!-- <v-tooltip top color="green darken-1">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              class="mr-2"
              color="green darken-1"
              @click="specialCondition(item)"
              v-bind="attrs"
              v-on="on"
            >
              mdi-book-cog-outline
            </v-icon>
          </template>
          <span>Condição Promocional</span>
        </v-tooltip> -->
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize"> Recarregar </v-btn>
      </template>
    </v-data-table>
    <v-dialog
      v-model="dialogPayments"
      hide-overlay
      persistent
      max-width="1050px"
    >
      <v-card>
        <v-card-title>Vincular Condições de Pagamento</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="mt-4">
          <v-row>
            <v-col>
              <v-autocomplete
                :items="filterPayments(paymentConditions)"
                item-text="name"
                item-value="id"
                v-model="paymentSelected"
                label="Condição de Pagamento"
                hide-details
                dense
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col>
              <v-select
                :items="typesCondition"
                v-model="typeCondition"
                label="Tipo"
                required
                dense
                outlined
                hide-details
              ></v-select>
            </v-col>
            <v-col>
              <v-btn color="blue darken-3" dark @click="addPayment()">
                Adicionar
                <v-icon right>mdi-plus</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-divider></v-divider>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <div class="elavation-5">
                <v-simple-table
                  dense
                  fixed-header
                  height="250px"
                  class="elavation-5"
                >
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-right text-no-wrap" width="40px">#</th>
                        <th class="text-left text-no-wrap">
                          Condição de Pagamento
                        </th>
                        <th class="text-left text-no-wrap" width="200px">
                          Tipo
                        </th>
                        <th class="text-left text-no-wrap" width="80px">
                          (%) Desconto
                        </th>
                        <th class="text-right text-no-wrap">Ação</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(payment, index) in paymentsByProvider"
                        :key="payment.payment.id"
                      >
                        <td class="text-right">{{ ++index }}</td>
                        <td>{{ payment.payment.name }}</td>
                        <td>Ambos</td>
                        <td>
                          <v-text-field
                            outlined
                            dense
                            hide-details
                            class="fs-12"
                            v-model.number="payment.discount"
                            suffix="%"
                          ></v-text-field>
                        </td>
                        <td class="text-right">
                          <v-tooltip top color="error">
                            <!-- eslint-disable-next-line -->
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                color="red darken-1"
                                @click="deletePayment(payment)"
                                v-bind="attrs"
                                v-on="on"
                              >
                                mdi-delete
                              </v-icon>
                            </template>
                            <span>Deletar</span>
                          </v-tooltip>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeDialogPayments()">
            Fechar
          </v-btn>
          <v-btn
            color="green darken-3"
            class="white--text"
            @click="confirmDialogPayments()"
          >
            <v-icon left>mdi-check</v-icon>
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogPromotionalCondition"
      hide-overlay
      persistent
      max-width="1040px"
    >
      <v-card>
        <v-card-title>Condições de Pagamento Promocional</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="mt-4">
          <v-row>
            <v-col cols="12" md="3">
              <v-autocomplete
                :items="filterPaymentsPromotional(paymentConditions)"
                item-text="name"
                item-value="id"
                v-model="paymentSelectedPromotional"
                label="Condição de Pagamento"
                hide-details
                dense
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                v-mask="dateMask"
                outlined
                dense
                hide-details
                v-model="startDate"
                label="Data Inicial"
                append-outer-icon="mdi-calendar"
                @click:append-outer="handlerCalendar('startDate')"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                v-mask="dateMask"
                outlined
                dense
                hide-details
                label="Data Final"
                v-model="endDate"
                append-outer-icon="mdi-calendar"
                @click:append-outer="handlerCalendar('endDate')"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                outlined
                dense
                hide-details
                class="fs-12"
                label="Desconto"
                v-model.number="promotionalDiscount"
                suffix="%"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-btn
                color="blue darken-3"
                dark
                @click="addPaymentPromotional()"
              >
                Adicionar
                <v-icon right>mdi-plus</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-divider></v-divider>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <div class="elavation-5">
                <v-simple-table
                  dense
                  fixed-header
                  height="250px"
                  class="elavation-5"
                >
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-right text-no-wrap" width="40px">#</th>
                        <th class="text-left text-no-wrap">
                          Condição de Pagamento
                        </th>
                        <th class="text-left text-no-wrap">Data Inicial</th>
                        <th class="text-left text-no-wrap">Data Final</th>
                        <th class="text-left text-no-wrap" width="80px">
                          (%) Desconto
                        </th>
                        <th class="text-right text-no-wrap">Ação</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(
                          payment, index
                        ) in promotionalPaymentsByProvider"
                        :key="payment.payment.id"
                      >
                        <td class="text-right">{{ ++index }}</td>
                        <td>{{ payment.payment.name }}</td>
                        <td>
                          {{ payment.startDate | dateFormatToBr }}
                        </td>
                        <td>
                          {{ payment.endDate | dateFormatToBr }}
                        </td>
                        <td class="text-right">{{ payment.discount }}%</td>
                        <td class="text-right">
                          <v-tooltip top color="error">
                            <!-- eslint-disable-next-line -->
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                color="red darken-1"
                                @click="deletePromotionalDiscount(payment)"
                                v-bind="attrs"
                                v-on="on"
                              >
                                mdi-delete
                              </v-icon>
                            </template>
                            <span>Deletar</span>
                          </v-tooltip>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closePromotionalDialog()">
            Fechar
          </v-btn>
          <v-btn
            color="green darken-3"
            class="white--text"
            @click="confirmPromotionalDialog()"
          >
            <v-icon left>mdi-check</v-icon>
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      ref="dialog"
      v-model="modalDate"
      :return-value.sync="dateDialog"
      width="290px"
    >
      <v-date-picker
        v-model="dateDialog"
        scrollable
        no-title
        @change="handlePickerDate"
      >
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="modalDate = false"> Fechar </v-btn>
      </v-date-picker>
    </v-dialog>
  </div>
</template>

<script>
import { URL } from "@/api/config";

import * as CompanyPaymentAPI from "@/api/requests/CompanyPaymentRequest";

import Alert from "@/components/Alert";
import AwesomeMask from "awesome-mask";

export default {
  components: {
    Alert,
  },
  directives: {
    mask: AwesomeMask,
  },
  data: () => ({
    dateMask: "99/99/9999",
    search: "",
    loading: false,
    typesCondition: [
      { value: "A", text: "Ambos" },
      { value: "P", text: "Planejamento" },
      { value: "E", text: "Pronta Entrega Express" },
    ],
    typeCondition: "A",
    headers: [
      {
        text: "ID",
        align: "right",
        value: "id",
        width: 50,
      },
      { text: "Fornecedor", value: "name", width: 350 },
      { text: "Condições de Pagamento", value: "payments", width: 200 },
      {
        text: "Ação",
        value: "actions",
        sortable: false,
        width: 130,
        align: "right",
      },
    ],
    providers: [],
    providerEdit: {
      id: "",
      name: "",
    },
    defaultItem: {
      name: "",
      status: 1,
    },
    dialogPayments: false,
    payments: [],
    paymentConditions: [],
    paymentSelected: "",
    paymentsByProvider: [],
    messageAlert: "",
    typeAlert: "",
    dialogPromotionalCondition: false,
    paymentSelectedPromotional: "",
    startDate: "",
    endDate: "",
    promotionalDiscount: "",
    promotionalPaymentsByProvider: [],
    dateDialog: "",
    modalDate: false,
    fieldDate: "",
  }),
  filters: {
    dateFormatToBr(date) {
      if (date == "") return "";
      return date.split("-").reverse().join("/");
    },
    dateFormatToEua(date) {
      if (date == "") return "";
      return date.split("/").reverse().join("-");
    },
  },

  computed: {},

  created() {
    this.initialize();
  },

  methods: {
    async initialize() {
      await this.getProviders();
      await this.getPaymentConditions();
    },
    async getProviders() {
      this.loading = true;
      this.providers = [];
      try {
        let data = await CompanyPaymentAPI.getAll("/providers");
        this.providers = data.sort((a, b) => (a.name > b.name ? 1 : -1));
        console.log(this.providers);
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async getPaymentsByProvider(id, type) {
      this.loading = true;
      this.paymentsByProvider = [];
      this.promotionalPaymentsByProvider = [];
      try {
        let data = await CompanyPaymentAPI.getAll(
          `?company_id=${id}&type=${type}`
        );
        if (type === "default") {
          this.paymentsByProvider = data;
        } else {
          this.promotionalPaymentsByProvider = data;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async getPaymentConditions() {
      this.loading = true;
      this.paymentConditions = [];
      try {
        let res = await fetch(`${URL}payment-condition`);
        let data = await res.json();
        this.paymentConditions = data.sort((a, b) =>
          a.name > b.name ? 1 : -1
        );
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    editItem(item) {
      this.providerEdit = item;
      this.dialogPayments = true;
      this.getPaymentsByProvider(this.providerEdit.id, "default");
    },
    closeDialogPayments() {
      this.dialogPayments = false;
    },
    confirmDialogPayments() {
      const data = {
        company_id: this.providerEdit.id,
        type: "default",
        payments: [],
      };
      data.payments = this.paymentsByProvider.map((item) => ({
        id: item.id,
        type: "default",
        company_id: this.providerEdit.id,
        payment_condition_id: item.payment.id,
        discount: item.discount,
      }));
      this.savePaymentConditions(data);
    },
    addPayment() {
      let payment = this.paymentConditions.find(
        (item) => item.id === this.paymentSelected
      );
      this.paymentsByProvider.push({
        id: "",
        payment: payment,
        payment_condition_id: payment.id,
        company_id: this.providerEdit.id,
        discount: 0,
      });
    },
    filterPayments(payments) {
      return payments.filter(
        (payment) =>
          this.paymentsByProvider.find(
            (item) => item.payment_condition_id === payment.id
          ) === undefined
      );
    },
    deletePayment(payment) {
      let index = this.paymentsByProvider.findIndex(
        (item) => item.payment.id === payment.payment.id
      );
      this.paymentsByProvider.splice(index, 1);
    },
    async savePaymentConditions(data) {
      this.loading = true;
      try {
        await CompanyPaymentAPI.post(data);
        if (data.type === "default") {
          this.dialogPayments = false;
        } else {
          this.dialogPromotionalCondition = false;
        }
        await this.getProviders();
        this.messageAlert = "Condições salvas com sucesso";
        this.typeAlert = "success";
      } catch (error) {
        console.log(error);
        this.messageAlert =
          "Não foi possível salvar as condições: " + error.message;
        this.typeAlert = "error";
      } finally {
        this.loading = false;
      }
    },
    specialCondition(item) {
      this.providerEdit = item;
      this.paymentSelectedPromotional = "";
      this.startDate = "";
      this.endDate = "";
      this.promotionalDiscount = "0";
      this.dialogPromotionalCondition = true;
      this.getPaymentsByProvider(this.providerEdit.id, "promotional");
    },
    filterPaymentsPromotional(payments) {
      return payments.filter(
        (payment) =>
          this.promotionalPaymentsByProvider.find(
            (item) => item.payment_condition_id === payment.id
          ) === undefined
      );
    },
    handlerCalendar(field) {
      let date = this[field];
      this.dateDialog = this.dateFormatToEua(date);
      this.fieldDate = field;
      this.modalDate = true;
    },
    dateFormatToBr(date) {
      if (date == "") return "";
      return date.split("-").reverse().join("/");
    },
    dateFormatToEua(date) {
      if (date == "") return "";
      return date.split("/").reverse().join("-");
    },
    handlePickerDate() {
      this[this.fieldDate] = this.dateFormatToBr(this.dateDialog);
      this.fieldDate = "";
      this.dateDialog = "";
      this.modalDate = false;
    },
    addPaymentPromotional() {
      let payment = this.paymentConditions.find(
        (item) => item.id === this.paymentSelectedPromotional
      );
      this.promotionalPaymentsByProvider.push({
        id: "",
        payment: payment,
        payment_condition_id: payment.id,
        company_id: this.providerEdit.id,
        discount: this.promotionalDiscount,
        startDate: this.startDate,
        endDate: this.endDate,
      });
    },
    deletePromotionalDiscount(payment) {
      let index = this.promotionalPaymentsByProvider.findIndex(
        (item) => item.payment.id === payment.payment.id
      );
      this.promotionalPaymentsByProvider.splice(index, 1);
    },
    closePromotionalDialog() {
      this.dialogPromotionalCondition = false;
    },
    confirmPromotionalDialog() {
      const data = {
        company_id: this.providerEdit.id,
        type: "promotional",
        payments: [],
      };
      data.payments = this.promotionalPaymentsByProvider.map((item) => ({
        id: item.id,
        type: "promotional",
        company_id: this.providerEdit.id,
        payment_condition_id: item.payment.id,
        discount: item.discount,
        startDate: this.dateFormatToEua(item.startDate),
        endDate: this.dateFormatToEua(item.endDate),
      }));
      this.savePaymentConditions(data);
    },
    getPaymentsProviderTable(item) {
      // console.log(item.payments
      //   .map((item) => item.id)
      //   .map((item) => this.paymentConditions.find((i) => (i.id == item)))
      // )
      //   .filter((item) => item !== undefined));
      // return [];
      return item.payments
        .map((item) => item.payment_condition_id)
        .map((item) => this.paymentConditions.find((i) => i.id == item))
        .filter((item) => item !== undefined)
        .sort((a, b) => (a.name > b.name ? 1 : -1));
    },
  },
};
</script>
